import gql from 'graphql-tag';

export default gql`
  query findManyTagQuery($filter: FilterFindManyTagInput) {
    findManyTagQuery(filter: $filter) {
      _id
      name
      alias
      type
      language
    }
  }
`;
